import React from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';

export interface Props
  extends Partial<React.ButtonHTMLAttributes<HTMLButtonElement>> {
  label: string;
  iconUrl?: string;
  variant?: 'outlined';
  btnRef?: any;
  spanProps?: Partial<React.ButtonHTMLAttributes<HTMLButtonElement>>;
}

export default function Button({
  label,
  iconUrl,
  variant,
  spanProps,
  btnRef,
  ...props
}: Props) {
  return (
    <button
      type="button"
      {...props}
      ref={btnRef}
      className={clsx(styles.container, props.className, {
        [styles.outlined]: variant === 'outlined',
      })}
    >
      {iconUrl && <img className={styles.icon} src={iconUrl} />}
      <span {...spanProps} className={clsx(styles.name, spanProps?.className)}>
        {label}
      </span>
    </button>
  );
}
